// constants.js

export const API_URL_PROD = "https://wsmobile.cnam-paysdelaloire.fr/";
export const API_URL_TEST = "http://192.168.2.168:153/";